
const confirmDialog = async function (_this, title){
  return _this.$swal({
    title: title,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: '確定',
    cancelButtonText: '取消'
    }).then((result) => {
      return (result.value)?true:false
    })
}


export default {
  confirmDialog: confirmDialog
}
